import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const ui = constants.colors.ui;

export const bodyStyles: CSSObject = {
  padding: "14px 20px",
};

export const loadingSpinnerStyles: CSSObject = {
  width: 64,
  height: 64,
  color: ui.core[600],
  display: "block",
  margin: "0 auto",
  padding: 8,
};

export const loadingLabelStyles: CSSObject = {
  color: ui.core[600],
  textAlign: "center",
  "&&&&": {
    fontSize: "14px",
    margin: "0",
    lineHeight: "114%",
    fontWeight: 700,
  },
};
